const formatTime = (dateString: string | null): string => {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};

export default formatTime;
